module.exports = __webpack_public_path__ + "img/compartir.1d041815.webp";